"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bind_decorator_1 = __importDefault(require("bind-decorator"));
const mobx_1 = require("mobx");
const ecommerce_1 = require("../../api/ecommerce");
const configuration_1 = __importDefault(require("../apis/configuration/shop/configuration"));
class ShopwareShippingMethods {
    api = new ecommerce_1.ShippingMethodApi(configuration_1.default);
    shippingServicesApi = new ecommerce_1.ShippingServiceApi(configuration_1.default);
    loading = false;
    internalShippingMethodList = [];
    shippingMethodServices = new Map();
    constructor() {
        (0, mobx_1.makeObservable)(this, {
            loading: mobx_1.observable,
            internalShippingMethodList: mobx_1.observable,
            shippingMethodServices: mobx_1.observable,
            shippingMethodList: mobx_1.computed,
            loadShippingMethods: mobx_1.action.bound,
            loadShippingMethodServices: mobx_1.action.bound,
            setShippingMethodList: mobx_1.action.bound,
        });
    }
    get shippingMethodList() {
        return this.internalShippingMethodList;
    }
    loadShippingMethods() {
        this.loading = true;
        return this.api
            .readShippingMethods({
            onlyAvailable: true,
        })
            .then((response) => {
            return this.setShippingMethodList(response?.elements ?? []);
        })
            .then(() => this.internalShippingMethodList)
            .catch(() => {
            this.setShippingMethodList([]);
            return Promise.reject();
        })
            .finally(() => {
            this.loading = false;
        });
    }
    loadShippingMethodServices(shippingMethod) {
        const { id, extensions } = shippingMethod;
        if (!id) {
            return Promise.reject();
        }
        let shippingServiceList = Promise.resolve([]);
        switch (extensions?.massiveShippingMethod?.type) {
            case ecommerce_1.ShippingMethodType.Ups:
                shippingServiceList = this.shippingServicesApi.readUpsShippingServiceList();
                break;
            case ecommerce_1.ShippingMethodType.FedEx:
                shippingServiceList = this.shippingServicesApi.readFedexShippingServiceList();
                break;
        }
        return shippingServiceList
            .then((services) => {
            services.sort((a, b) => a.position - b.position);
            this.shippingMethodServices.set(id, services);
        })
            .catch(() => {
            this.shippingMethodServices.set(id, []);
            return Promise.reject();
        });
    }
    getShippingMethodServices(shippingMethod) {
        return shippingMethod.id ? this.shippingMethodServices.get(shippingMethod.id) : undefined;
    }
    setShippingMethodList(shippingMethodList) {
        this.internalShippingMethodList = shippingMethodList;
    }
}
__decorate([
    bind_decorator_1.default
], ShopwareShippingMethods.prototype, "getShippingMethodServices", null);
exports.default = new ShopwareShippingMethods();
